import { Box, Typography } from "@material-ui/core";

export const BlockedIcon = () => (
	<Box
		bgcolor="gold"
		height={19}
		width={19}
		borderRadius={19}
		display="flex"
		alignItems="center"
		justifyContent="center"
		// marginLeft={1}
	>
		<Typography
			style={{
				paddingTop: 1,
				userSelect: "none",
				fontSize: 12,
				textAlign: "center",
				color: "white",
			}}
		>
			<b>!</b>
		</Typography>
	</Box>
);
